import type { Trade } from "wasp/entities";

/** Trade tel que les pages Lite le manipulent, dérivé d'un Trade réel. */
export interface LiteTrade {
  id: string;
  accountId: string | null;
  strategyIds: string[];
  symbol: string;
  side: "long" | "short";
  qty: number;
  entry: number;
  exit: number | null;
  openedAt: string;
  closedAt: string;
  /** P&L brut (convention de l'app). */
  pnl: number;
  /** Commission + swaps, négatifs (convention de l'app). */
  fees: number;
  closed: boolean;
  tags: { id: string; name: string }[];
  note: string;
  setupRating: number | null;
  raw: Trade;
}

export type Period = "today" | "week" | "month" | "3m" | "6m" | "all";

/** Groupe de comptes du filtre « Compte », exclusif avec un compte précis. */
export type AccountSet = "all" | "active" | "challenge" | "funded";

export interface LiteFilters {
  period: Period;
  accountId: string | null;
  /** null = défaut de la page (comptes actifs ; tous les comptes sur le Prop Firm Manager). */
  accountSet: AccountSet | null;
  /** Prop firm : id de template, ou "personal" pour les comptes sans prop firm. */
  firm: string | null;
  strategyId: string | null;
}

export function toLiteTrade(t: Trade & { strategies?: { id: string }[]; tags?: { id: string; name: string }[] }): LiteTrade {
  const opened = new Date(t.date).toISOString();
  return {
    id: t.id,
    accountId: t.accountId ?? null,
    strategyIds: (t.strategies ?? []).map(s => s.id),
    symbol: t.symbol,
    side: t.type === "short" ? "short" : "long",
    qty: t.quantity,
    entry: t.entryPrice,
    exit: t.exitPrice ?? null,
    openedAt: opened,
    closedAt: t.exitDate ? new Date(t.exitDate).toISOString() : opened,
    pnl: t.pnl ?? 0,
    fees: (t.commission ?? 0) + (t.swaps ?? 0),
    closed: t.pnl !== null && t.pnl !== undefined,
    tags: t.tags ?? [],
    note: t.notes ?? "",
    setupRating: t.setupRating ?? null,
    raw: t,
  };
}
